import { NavigationLayoutViewModel, NavigationViewModel } from '../core/navigation/navigation.viewModel';
import { IArenaLayoutPlugin } from './arena-layout-plugin.model';

export interface IArenaPluginInfo {
  getLayoutPlugins?: (navigationLayout: NavigationLayoutViewModel) => Promise<IArenaLayoutPlugin[]>;
}

export interface IArenaPlugin {
  update?: (navigationDocument: NavigationViewModel) => Promise<IArenaPluginInfo>;
  updateNotificationInfos?: () => Promise<void>;
}

export abstract class ArenaPlugin implements IArenaPlugin, IArenaPluginInfo {
  constructor(private factory: (navigationLayout: NavigationLayoutViewModel) => Promise<IArenaLayoutPlugin[]>) {}

  private _navigationDocument: NavigationViewModel;
  public get navigationDocument(): NavigationViewModel {
    return this._navigationDocument;
  }

  public async update(navigationDocument: NavigationViewModel): Promise<IArenaPluginInfo> {
    this._navigationDocument = navigationDocument;
    return this;
  }

  public updateNotificationInfos?: () => Promise<void>;

  public async getLayoutPlugins(navigationLayout: NavigationLayoutViewModel): Promise<IArenaLayoutPlugin[]> {
    const result: IArenaLayoutPlugin[] = [];
    if (this.factory) {
      const plugins = await this.factory(navigationLayout);
      if (plugins) {
        result.push(...plugins);
      }
    }

    return result;
  }
}
